module.exports = __webpack_public_path__ + "static/media/fly0249.6699a3c8.webp";